var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 20 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.82031 0.924805C1.90781 0.924805 0.367188 2.3748 0.367188 4.17481V25.5498C0.367188 27.3498 1.90781 28.8252 3.82031 28.8252H14.1797C16.0922 28.8252 17.6328 27.3752 17.6328 25.5752V4.17481C17.6328 2.3748 16.0922 0.924805 14.1797 0.924805H3.82031ZM3.82031 2.4248H14.1797C15.2156 2.4248 16.0391 3.19981 16.0391 4.17481V22.4751H1.96094V4.17481C1.96094 3.19981 2.78437 2.4248 3.82031 2.4248ZM7.53906 3.625C7.0875 3.625 6.74219 3.95 6.74219 4.375C6.74219 4.8 7.0875 5.125 7.53906 5.125H10.4609C10.9125 5.125 11.2578 4.8 11.2578 4.375C11.2578 3.95 10.9125 3.625 10.4609 3.625H7.53906ZM8.20312 10.375V12.625H5.8125V14.125H8.20312V16.375H9.79688V14.125H12.1875V12.625H9.79688V10.375H8.20312ZM1.96094 24H16.0391V25.5498C16.0391 26.5248 15.2156 27.2998 14.1797 27.2998H3.82031C2.78437 27.2998 1.96094 26.5248 1.96094 25.5498V24ZM9 24.8936C8.79414 24.8936 8.58838 24.9626 8.44229 25.1001C8.28292 25.2501 8.20312 25.425 8.20312 25.625C8.20312 25.825 8.28292 26.0249 8.44229 26.1499C8.5751 26.2999 8.7875 26.375 9 26.375C9.2125 26.375 9.4249 26.2999 9.55771 26.1499C9.71708 25.9999 9.79688 25.825 9.79688 25.625C9.79688 25.425 9.71708 25.2251 9.55771 25.1001C9.41162 24.9626 9.20586 24.8936 9 24.8936Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/phone.4f20533076e124d66243eef6550cc7dd.svg";